import { html } from 'lit-element';
import { expandToSeeResponseStyles } from '../cssUtils.js';
import { CustomLitElement } from '../CustomLitElement.js';

/**
 * @element categorize-response
 * @prop {Object} model - The model for the pie
 * @prop {Object} session - The response session
 * @cssprop --pie-live-session-background-color - change the background color
 * @cssprop --pie-live-session-font-family - change the font family
 * @cssprop --pie-live-session-response-height - change the height (must be valid, eg: 100px, 10em )
 * @cssprop --pie-live-session-response-width - change the width (must be valid, eg: 100px, 10em )
 */
export class CategorizeResponse extends CustomLitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      session: { type: Array, attribute: false },
    };
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html` <style>
        ${expandToSeeResponseStyles}
      </style>
      <div class="expand-response">
        Expand to see student response
        <!--      <div class="magnifier">&#9906;</div>-->
      </div>`;
  }
}

export default CategorizeResponse;
